/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x6080806040523461001657610f2b908161001c8239f35b600080fdfe608060408181526004918236101561001657600080fd5b600092833560e01c91826301ffc9a7146107875750816306fdde03146106ba578163081812fc14610692578163095ea7b3146104fa57816323b872dd146104d057816342842e0e146104a75781636352211e1461047757816370a08231146103cd57816395d89b41146102b3578163a22cb465146101e3578163b88d4fde14610155578163c87b56dd14610104575063e985e9c5146100b457600080fd5b3461010057806003193601126101005760ff816020936100d2610896565b6100da6108b1565b6001600160a01b039182168352606a875283832091168252855220549151911615158152f35b5080fd5b838334610100576020366003190112610100576101246101519335610d19565b818151610130816108fc565b5280519161013d836108fc565b825251918291602083526020830190610856565b0390f35b919050346101df5760803660031901126101df57610171610896565b6101796108b1565b846064359467ffffffffffffffff8611610100573660238701121561010057850135946101b16101a887610950565b9551958661092e565b858552366024878301011161010057856101dc96602460209301838801378501015260443591610a70565b80f35b8280fd5b919050346101df57806003193601126101df576101fe610896565b90602435918215158093036102af576001600160a01b03169283331461026d5750338452606a60205280842083855260205280842060ff1981541660ff8416179055519081527f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c3160203392a380f35b6020606492519162461bcd60e51b8352820152601960248201527f4552433732313a20617070726f766520746f2063616c6c6572000000000000006044820152fd5b8480fd5b8284346103ca57806003193601126103ca578151918160665492600184811c918186169586156103c0575b60209687851081146103ad578899509688969785829a52918260001461038657505060011461032a575b505050610151929161031b91038561092e565b51928284938452830190610856565b9190869350606683527f46501879b8ca8525e8c2fd519e2fbfcfa2ebea26501294aa02cbfcfb12e943545b82841061036e575050508201018161031b610151610308565b8054848a018601528895508794909301928101610355565b60ff19168782015293151560051b8601909301935084925061031b91506101519050610308565b60248360228c634e487b7160e01b835252fd5b92607f16926102de565b80fd5b83915034610100576020366003190112610100576001600160a01b036103f1610896565b1690811561040e5760208480858581526068845220549051908152f35b608490602085519162461bcd60e51b8352820152602960248201527f4552433732313a2061646472657373207a65726f206973206e6f74206120766160448201527f6c6964206f776e657200000000000000000000000000000000000000000000006064820152fd5b8284346103ca5760203660031901126103ca57506001600160a01b0361049f602093356109b7565b915191168152f35b505034610100576101dc906104bb366108c7565b919251926104c8846108fc565b858452610a70565b83346103ca576101dc6104e2366108c7565b916104f56104f08433610b06565b6109ff565b610be5565b9050346101df57816003193601126101df57610514610896565b90602435926001600160a01b0391828061052d876109b7565b169416938085146106295780331490811561060a575b50156105a25750838552606960205284208273ffffffffffffffffffffffffffffffffffffffff1982541617905561057a836109b7565b167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b9258480a480f35b6020608492519162461bcd60e51b8352820152603d60248201527f4552433732313a20617070726f76652063616c6c6572206973206e6f7420746f60448201527f6b656e206f776e6572206f7220617070726f76656420666f7220616c6c0000006064820152fd5b90508652606a60205281862033875260205260ff828720541638610543565b506020608492519162461bcd60e51b8352820152602160248201527f4552433732313a20617070726f76616c20746f2063757272656e74206f776e6560448201527f72000000000000000000000000000000000000000000000000000000000000006064820152fd5b8284346103ca5760203660031901126103ca57506001600160a01b0361049f602093356109dc565b8284346103ca57806003193601126103ca578151918160655492600184811c9181861695861561077d575b60209687851081146103ad578899509688969785829a52918260001461038657505060011461072157505050610151929161031b91038561092e565b9190869350606583527f8ff97419363ffd7000167f130ef7168fbea05faf9251824ca5043f113cc6a7c75b828410610765575050508201018161031b610151610308565b8054848a01860152889550879490930192810161074c565b92607f16926106e5565b8491346101df5760203660031901126101df57357fffffffff0000000000000000000000000000000000000000000000000000000081168091036101df57602092507f80ac58cd00000000000000000000000000000000000000000000000000000000811490811561082c575b8115610802575b5015158152f35b7f01ffc9a700000000000000000000000000000000000000000000000000000000915014836107fb565b7f5b5e139f00000000000000000000000000000000000000000000000000000000811491506107f4565b919082519283825260005b848110610882575050826000602080949584010152601f8019910116010190565b602081830181015184830182015201610861565b600435906001600160a01b03821682036108ac57565b600080fd5b602435906001600160a01b03821682036108ac57565b60609060031901126108ac576001600160a01b039060043582811681036108ac579160243590811681036108ac579060443590565b6020810190811067ffffffffffffffff82111761091857604052565b634e487b7160e01b600052604160045260246000fd5b90601f8019910116810190811067ffffffffffffffff82111761091857604052565b67ffffffffffffffff811161091857601f01601f191660200190565b1561097357565b606460405162461bcd60e51b815260206004820152601860248201527f4552433732313a20696e76616c696420746f6b656e20494400000000000000006044820152fd5b60005260676020526001600160a01b03604060002054166109d981151561096c565b90565b6109e581610d19565b60005260696020526001600160a01b036040600020541690565b15610a0657565b608460405162461bcd60e51b815260206004820152602d60248201527f4552433732313a2063616c6c6572206973206e6f7420746f6b656e206f776e6560448201527f72206f7220617070726f766564000000000000000000000000000000000000006064820152fd5b90610a94939291610a846104f08433610b06565b610a8f838383610be5565b610d3c565b15610a9b57565b60405162461bcd60e51b815260206004820152603260248201527f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560448201527f63656976657220696d706c656d656e74657200000000000000000000000000006064820152608490fd5b906001600160a01b038080610b1a846109b7565b16931691838314938415610b4d575b508315610b37575b50505090565b610b43919293506109dc565b1614388080610b31565b909350600052606a60205260406000208260005260205260ff604060002054169238610b29565b15610b7b57565b608460405162461bcd60e51b815260206004820152602560248201527f4552433732313a207472616e736665722066726f6d20696e636f72726563742060448201527f6f776e65720000000000000000000000000000000000000000000000000000006064820152fd5b90610c0d91610bf3846109b7565b916001600160a01b03938493848094169485911614610b74565b16918215610cb05781610c2a91610c23866109b7565b1614610b74565b7fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef600084815260696020526040812073ffffffffffffffffffffffffffffffffffffffff199081815416905583825260686020526040822060001981540190558482526040822060018154019055858252606760205284604083209182541617905580a4565b608460405162461bcd60e51b8152602060048201526024808201527f4552433732313a207472616e7366657220746f20746865207a65726f2061646460448201527f72657373000000000000000000000000000000000000000000000000000000006064820152fd5b6000526067602052610d3a6001600160a01b0360406000205416151561096c565b565b92939190803b15610eeb57610da89460405180927f150b7a0200000000000000000000000000000000000000000000000000000000948583523360048401526001600160a01b03809816602484015260448301526080606483015281806020998a956084830190610856565b03916000988991165af1849181610e93575b50610e6a575050503d600014610e62573d610dd481610950565b90610de2604051928361092e565b81528091833d92013e5b80519182610e5f5760405162461bcd60e51b815260206004820152603260248201527f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560448201527f63656976657220696d706c656d656e74657200000000000000000000000000006064820152608490fd5b01fd5b506060610dec565b7fffffffff00000000000000000000000000000000000000000000000000000000161492509050565b9091508581813d8311610ee4575b610eab818361092e565b810103126102af57517fffffffff00000000000000000000000000000000000000000000000000000000811681036102af579038610dba565b503d610ea1565b505091505060019056fea26469706673582212201c8f588d4924ca7e615de7416c99ff47d5cbcb244401631881422d91892e5ddc64736f6c63430008140033";
const isSuperArgs = (xs) => xs.length > 1;
export class ERC721Upgradeable__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
ERC721Upgradeable__factory.bytecode = _bytecode;
ERC721Upgradeable__factory.abi = _abi;
